import { useState } from 'react';
import {
  Column,
  NavigationFilter,
  PaletteInput,
  PrimaryButton,
  ThinBorderStyle,
} from './DesignSystem';
import { Palette } from './Palette';
import { NewVersionID, useVersions, VersionPreview } from './VersionsPreview';
import { useConversation } from '@/services/ConversationService';

export const EnableVersions = false;
export function VersionsPalette() {
  const { dispatch, state } = useVersions();
  const { dispatch: conversationDispatch } = useConversation();
  const [newVersionName, setNewVersionName] = useState<string>('');

  if (!EnableVersions) {
    return <></>;
  }

  const hasUnversionedItems = state.unversionedItems.length > 0;

  return (
    <Palette title="Versions" windowID="versions">
      <Column>
        {
          <NavigationFilter
            options={['Select', 'Compare']}
            onSelection={(mode) =>
              dispatch({ type: 'set-mode', mode: mode as 'Select' | 'Compare' })
            }
          />
        }

        {state.versions.map((v) => {
          const isActiveVersion =
            state.mode === 'Select' ? state.activeVersionID === v.id : false;
          const isComparisonVerion =
            state.mode === 'Compare' &&
            (state.comparisonIDs.a === v.id || state.comparisonIDs.b === v.id);
          return (
            <div
              key={v.id}
              style={{ marginBlockStart: 8 }}
              onClick={() => {
                if (state.mode === 'Compare') {
                  dispatch({
                    type: 'select-comparison-version',
                    versionID: v.id,
                  });
                } else {
                  dispatch({ type: 'select-version', versionID: v.id });
                }
              }}
            >
              <VersionPreview
                name={v.name}
                isActiveVersion={isActiveVersion || isComparisonVerion}
              />
            </div>
          );
        })}

        {hasUnversionedItems && (
          <Column>
            <PaletteInput
              style={{
                ...ThinBorderStyle,
                backgroundColor: 'white',
                paddingBlock: 8,
                marginBlockStart: 8,
                marginBlockEnd: 4,
              }}
              value={newVersionName}
              onChange={(newVersionName) => setNewVersionName(newVersionName)}
              type={'text'}
              placeholder={'Name Version'}
            />
            <PrimaryButton
              text={'Create Version'}
              isDisabled={state.unversionedItems.length === 0}
              onClick={() => {
                if (newVersionName === '') {
                  return;
                }

                conversationDispatch({
                  type: 'add-drafts',
                  draftItems: [
                    {
                      type: 'createVersion',
                      id: NewVersionID(),
                      name: newVersionName,
                    },
                  ],
                });
              }}
            />
          </Column>
        )}
      </Column>
    </Palette>
  );
}
